document.addEventListener('DOMContentLoaded',function(){
  var toggle=document.querySelector('[data-zze-menu-toggle]'),nav=document.querySelector('[data-zze-nav]');
  if(toggle&&nav){toggle.addEventListener('click',function(){var open=nav.hasAttribute('data-open');if(open)nav.removeAttribute('data-open');else nav.setAttribute('data-open','');toggle.setAttribute('aria-expanded',String(!open));});}
});

/* Gallery interactions are scoped to product pages and do not alter the ZZEMPIRE logo. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-zze-product-gallery]').forEach(function(gallery){
    var thumbs=Array.prototype.slice.call(gallery.querySelectorAll('[data-zze-gallery-thumb]'));
    var main=gallery.querySelector('[data-zze-gallery-main]');
    var openButton=gallery.querySelector('[data-zze-gallery-open]');
    var modal=gallery.querySelector('[data-zze-gallery-modal]');
    var zoom=gallery.querySelector('[data-zze-gallery-zoom]');
    var counter=gallery.querySelector('[data-zze-gallery-counter]');
    var modalCounter=gallery.querySelector('[data-zze-gallery-modal-counter]');
    var closeButton=gallery.querySelector('[data-zze-gallery-close]');
    var prev=gallery.querySelector('[data-zze-gallery-prev]');
    var next=gallery.querySelector('[data-zze-gallery-next]');
    if(!thumbs.length || !main || !modal || !zoom || !openButton)return;
    var active=0,oldOverflow='',returnFocus=null,startX=null;
    function show(index){
      active=(index+thumbs.length)%thumbs.length;
      var thumb=thumbs[active];
      main.src=thumb.dataset.zzeLarge;
      main.removeAttribute('srcset');
      main.alt=thumb.dataset.zzeAlt || '';
      thumbs.forEach(function(t,i){t.classList.toggle('is-active',i===active);t.setAttribute('aria-pressed',String(i===active));});
      var label='Photo '+(active+1)+' of '+thumbs.length;
      if(counter)counter.textContent=label+' · Tap or click the large image to zoom';
      if(modalCounter)modalCounter.textContent=label;
      if(!modal.hidden){zoom.src=thumb.dataset.zzeZoom || thumb.dataset.zzeLarge;zoom.alt=main.alt;}
    }
    function open(){
      returnFocus=document.activeElement;
      oldOverflow=document.body.style.overflow;
      modal.hidden=false;
      document.body.style.overflow='hidden';
      zoom.src=thumbs[active].dataset.zzeZoom||thumbs[active].dataset.zzeLarge;
      zoom.alt=thumbs[active].dataset.zzeAlt||'';
      if(modalCounter)modalCounter.textContent='Photo '+(active+1)+' of '+thumbs.length;
      if(prev)prev.hidden=thumbs.length<2;
      if(next)next.hidden=thumbs.length<2;
      closeButton.focus();
    }
    function close(){
      if(modal.hidden)return;
      modal.hidden=true;
      document.body.style.overflow=oldOverflow;
      zoom.removeAttribute('src');
      if(returnFocus&&typeof returnFocus.focus==='function')returnFocus.focus();
    }
    thumbs.forEach(function(t,i){t.addEventListener('click',function(){show(i);});});
    openButton.addEventListener('click',open);
    closeButton.addEventListener('click',close);
    if(prev)prev.addEventListener('click',function(){show(active-1);});
    if(next)next.addEventListener('click',function(){show(active+1);});
    modal.addEventListener('click',function(e){if(e.target===modal)close();});
    modal.addEventListener('keydown',function(e){
      if(e.key==='Escape'){e.preventDefault();close();}
      if(e.key==='ArrowRight'){e.preventDefault();show(active+1);}
      if(e.key==='ArrowLeft'){e.preventDefault();show(active-1);}
      if(e.key==='Tab'){
        var focusable=[closeButton,prev,next].filter(function(n){return n&&!n.hidden;});
        var cur=focusable.indexOf(document.activeElement);
        if(e.shiftKey&&cur===0){e.preventDefault();focusable[focusable.length-1].focus();}
        else if(!e.shiftKey&&cur===focusable.length-1){e.preventDefault();focusable[0].focus();}
      }
    });
    modal.addEventListener('touchstart',function(e){startX=e.changedTouches[0].clientX;},{passive:true});
    modal.addEventListener('touchend',function(e){
      if(startX===null)return;
      var diff=e.changedTouches[0].clientX-startX;startX=null;
      if(Math.abs(diff)>50){show(active+(diff<0?1:-1));}
    },{passive:true});
    show(0);
  });
});
